import { Spin } from 'antd';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import store, { persistor } from '@/redux/store';

const PersistLoading = (
  <div className="flex h-screen items-center justify-center">
    <Spin size="large" />
  </div>
);

export const ReduxProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={PersistLoading} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  );
};
